import { ThunkType } from "../../../../../core/store/reducers";
import { getDailySecurityExcel } from "../api/getDailySecurityExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../dailySecurityDataSlice";

export const downloadDailySecurityExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.securityCommission.dailySecurity;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getDailySecurityExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "DailySecurityTrading.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));

  console.log(dailyTrading);
};
